import React from 'react';
import { ComposableModal, ModalContent, ModalFooter } from '#app/components/ModalForm';
import { Button } from 'finform';
import Forgot from '../../../../pages/Auth/Forgot';

const ForgotModal = ({ show, handleCloseModal, handleLoginModal, i18n }) => (
  <ComposableModal
    size="extra-small"
    show={show}
    trigger=""
    title={i18n.auth?.forgotPassword}
    onClose={handleCloseModal}
    closeButtonVariant="landing"
  >
    <ModalContent>
      <Forgot callback={handleLoginModal} />
    </ModalContent>
    <ModalFooter>
      <Button wide type="cancel" onClick={handleCloseModal}>
        {i18n.auth?.cancel}
      </Button>
    </ModalFooter>
  </ComposableModal>
);

export default ForgotModal;
